import { ListItemText } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ListItemTextContainer = styled(ListItemText)(() => ({
  marginLeft: "10px",
  fontSize: "12px",
  fontFamily: '"Poppins", "sans-serif"',
}));
